import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { RealEstate } from "types/RealEstate";
import { handleRequestError } from "utils/Request";

export const REAL_ESTATE_SEARCH_MIN_LENGTH = 2;

async function fetchRealEstates(search: string): Promise<RealEstate[]> {
  const { data } = await api.get('/tecimob/real-estates', {
    params: { search },
  });
  return data;
}

export function useRealEstates(search: string) {
  const query = useQuery(
    ['real-estates', search],
    () => fetchRealEstates(search),
    {
      enabled: search.length >= REAL_ESTATE_SEARCH_MIN_LENGTH,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Um erro ocorreu ao buscar as imobiliárias. Por favor, tente novamente!');
  }, [query.isError, query.error]);

  return query;
}
